import RunExclusiveProgramIcon from '../../src/assets/images/exc-program.svg';
import ZeroDependencyIcon from '../../src/assets/images/zero-dependency.svg';
import InstantCashFlowIcon from '../../src/assets/images/instant-cash-flow.svg';
import HassleFreeIcon from '../../src/assets/images/cover-charge.svg';
import FasterOpsIcon from '../../src/assets/images/settings-icon.svg';
import BrandLoyaltyIcon from '../../src/assets/images/brand-boost.svg';
import { PaymentFlow } from '../features/rista-card/types/payment';

export const ZeroScreenFeaturesData = [
  {
    icon: RunExclusiveProgramIcon,
    title: "Run exclusive programs",
    desc: "- offer cards for members only deals & limited time campaigns."
  },
  {
    icon: ZeroDependencyIcon,
    title: "Zero-dependency on phone or cash",
    desc: " no need for mobile or cash payments."
  },
  {
    icon: InstantCashFlowIcon,
    title: "Instant cash flow",
    desc: "- get paid before the order is prepared."
  },
  {
    icon: HassleFreeIcon,
    title: "Hassle-free cover charge",
    desc: "- issue prepaid entry cards instead of paper slips."
  },
  {
    icon: FasterOpsIcon,
    title: "Faster operations",
    desc: "- reduce errors and save staff time."
  },
  {
    icon: BrandLoyaltyIcon,
    title: "Boost brand loyalty",
    desc: "- use stylish prepaid cards customers want to keep and reuse."
  }
];

export const modalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: '12px',
  boxShadow: 24,
  p: 4,
  minWidth: 513,
  maxHeight: '90vh',
  overflow: 'auto',
};

export const dataGridStyle = {
  height: "calc(100vh - 25px)",
  display: "flex",
  backgroundColor: "#fff",
  ".MuiDataGrid-columnHeaders": {
    background: "rgba(246, 246, 246, 1)",
    marginLeft: '8px',
    marginRight: '8px',
  },
  ".MuiDataGrid-columnHeaderTitle": {
    fontWeight: "600",
    color: "rgba(127, 127, 127, 1)",
  },
  ".MuiDataGrid-row": {
    marginLeft: '8px',
    marginRight: '8px',
  },
  ".MuiDataGrid-selectedRowCount": { visibility: "hidden!important" },
  ".MuiTablePagination-selectLabel": { visibility: "hidden!important" },
  ".MuiDataGrid-menuIconButton": { visibility: "hidden!important" },
  "div[class*='-toolbarQuickFilter']": { width: "40%", marginBottom: "10px" },
  ".MuiDataGrid-cell:focus ": { outline: "none!important" },
  ".MuiDataGrid-iconSeparator": { display: "none" },
  ".Mui-selected": { backgroundColor: "white!important" },
  ".MuiDataGrid-main": { overflowY: "auto" },
};

export const labelStyle = {
  fontFamily: "Inter",
  fontWeight: 400,
  fontSize: 14,
  color: "rgba(78,78,78,1)",
};

export const valueStyle = {
  fontFamily: "Inter",
  fontWeight: 500,
  fontSize: 14,
  color: "rgba(0,0,0,1)",
  whiteSpace: "normal",
  overflowWrap: "break-word",
};

export const DELETE_CARD_MODAL_MESSAGE = "Are you sure you want to delete this card? Once deleted, this card number cannot be used again to create a new card or to make transactions.";
export const EDIT_CARD_MODAL_HEADER = "Edit card details";
export const CREATE_CARD_MODAL_HEADER = "Create a New Card";
export const UPLOAD_CARDS_MODAL_HEADER = "Instructions to upload";
export const UPLOAD_CARDS_MODAL_INSTRUCTIONS = [
  "Upload can be performed by a Manager or an Admin, as applicable, with an email address verified in the account.",
  "Tap on the \"Send me Template\" button at the bottom to receive an email with a template as an attachment and a detailed instructions to prepare your data for uploading to your account.",
  "Prepare the data for upload in the standard comma-separated values (CSV) format, saved from Excel or similar spreadsheet software",
  "Enter data of each record in a separate row and the fields under the respective columns shown on the template.",
  "The maximum length of characters allowed in each field is indicated within parenthesis on the instructions.",
  "The fields that are mandatory are indicated against the respective field on the instructions.",
  "Upon upload of a file, any data errors found by the system will be indicated against each record on the last column and sent to you via email for corrections.",
  "Upon successful upload, you will receive an email from the system indicating the number of records uploaded to your account along with further instructions, if any, to process the uploaded data.",
];
export const ERROR_UPLOADEDING_CARDS_MODAL_HEADER = "Errors found in the uploaded file";
export const ERROR_UPLOADEDING_CARDS_MODAL_MESSAGE = "Your attempt to upload Update Rista Cards records for Harshit test Business has failed due to certain error in the data. The attached file contains the Update Rista Cards records along with the error messages listed on the last column. Please correct the data and upload it again.";

export const phoneNumberRegex = /^(?:\+91[\s-]?)?[6-9]\d{9}$/;

export const VISIBLE_FIELDS = ["cardNumber", "phoneNumber", "name", "balance", "status", "createdAt", "expiryDate", "actions"];

export const REST_UPLOAD_VALIDATION_ERROR = "REST_UPLOAD_VALIDATION_ERROR";
export const FILE_UPLOADED_SUCCESSFULLY = "FILE_UPLOADED_SUCCESSFULLY";

export const ADD_BALANCE_ERROR_FOR_EXPIRED_CARDS = "Balance cannot be added to expired cards.";

export const REFUND_ERROR_FOR_EXPIRED_CARDS = "Balance from expired cards cannot be refunded.";

export const UPLOAD_RISTA_CARDS = "Upload Rista cards";
export const EXPORT_RISTA_CARDS = "Export Rista cards";

export const PAGE_SIZE = 10;
export interface CreateCardModalProps {
  isOpen: boolean;
  onClose: () => void;
  handleOpenSuccessModal: () => void;
  handleCancel: () => void;
  currentCardData?: any;
  isEditMode?: boolean;
  togglePaymentModal?: (flow: PaymentFlow) => void;
  onDeleteCard?: () => void;
};
export interface ITextFieldConfig {
  placeHolder: string;
  fieldLabel: string;
  value: string;
  customClass?: string;
  parentClass?: string;
  boxWidth?: string;
  rows?: number;
  key: string;
  regexCheck?: any;
  maxLength?: number;
  isMandatory?: boolean;
  errorMessage?: string;
  handleChange?: (val: string) => void;
  disabled?: boolean;
  isNumericInput?: boolean;
};

export enum CardFieldKeyEnum {
  CardNumber = 'cardNumber',
  Name = 'name',
  ExpiryDate = 'expiryDate',
  PhoneNumber = 'phoneNumber',
  ExpiryTime = 'expiryTime',
}

export const paymnetsKeyMapping: any = {
  "paytmedc": "Paytm EDC",
  "paytmqr": "Paytm QR",
  "paytmqdqr": "Paytm DQR",
  "razorpay": 'Razorpay',
  "pinelabs": "Pine labs",
  "pine-lab": "Pine Labs",
  "paytmdqr": "Paytm DQR",
  "phonepeupi": "Phonepay Upi",
  "qwikcilver": "Qwikcilver"
}